import React from "react";
import "./Gallery.css";

const importAll = (r) => r.keys().map((key) => ({ src: r(key), caption: key.split('/').pop() }));

const images = importAll(require.context('../Gallery/salaiban photos', false, /\.(png|jpe?g|svg)$/));


const Gallery = () => {
  return (
    <div className="gallery-container">
      {images.map((image) => (
        <div key={image.id} className="gallery-item">
          <img src={image.src} alt={`Gallery ${image.id}`} />
          <div className="gallery-caption">Salaiban</div>
        </div>
      ))}
    </div>
  );
};

export default Gallery;
